module.exports = __webpack_public_path__ + "img/0Y4A8442_.a4cf8b75.jpg";